{
  "consent.action-accept": "Allow",
  "consent.action-reject": "Deny",
  "consent.description": "Only grant permissions if you trust this site or app. You do not need to accept all permissions.",
  "consent.privacy-policy-label": "Privacy Policy",
  "consent.remember-label": "Remember this decision for next time. The application will not be able to ask for additional permissions without your consent.",
  "consent.remember-tooltip": "remember my decision",
  "consent.requested-permissions-label": "The application requests access to the following permissions:",
  "consent.terms-of-service-label": "Terms of Service",
  "error.back-button": "Go Back",
  "error.description": "An error occurred with the following message:",
  "error.support-email-link": "If the problem persists, please contact <a>{contactSupportEmail}</a>",
  "error.title": "An error occurred",
  "error.title-internal-server-error": "Internal Server Error",
  "error.title-not-found": "404 - Page not found",
  "identities.messages.1010001": "Sign in",
  "identities.messages.1010002": "Sign in with {provider}",
  "identities.messages.1010003": "Please confirm this action by verifying that it is you.",
  "identities.messages.1010004": "Please complete the second authentication challenge.",
  "identities.messages.1010005": "Verify",
  "identities.messages.1010006": "Authentication code",
  "identities.messages.1010007": "Backup recovery code",
  "identities.messages.1010008": "Continue with hardware key",
  "identities.messages.1010009": "Continue",
  "identities.messages.1010010": "Continue",
  "identities.messages.1010011": "Sign in with hardware key",
  "identities.messages.1010012": "Prepare your WebAuthn device (e.g. security key, biometrics scanner, ...) and press continue.",
  "identities.messages.1010013": "Continue",
  "identities.messages.1010014": "A code has been sent to the address you provided. If you have not received an message, check the spelling of the address and retry the login.",
  "identities.messages.1010015": "Send sign in code",
  "identities.messages.1010016": "You tried to sign in with \"{duplicateIdentifier}\", but that email is already used by another account. Sign in to your account with one of the options below to add your account \"{duplicateIdentifier}\" at \"{provider}\" as another way to sign in.",
  "identities.messages.1010017": "Sign in and link",
  "identities.messages.1010018": "Confirm with {provider}",
  "identities.messages.1010019": "Request code to continue",
  "identities.messages.1010021": "Sign in with passkey",
  "identities.messages.1010022": "Sign in with password",
  "identities.messages.1010023": "Send code to {address}",
  "identities.messages.1040001": "Sign up",
  "identities.messages.1040002": "Sign up with {provider}",
  "identities.messages.1040003": "Continue",
  "identities.messages.1040004": "Sign up with security key",
  "identities.messages.1040005": "A code has been sent to the address(es) you provided. If you have not received a message, check the spelling of the address and retry the registration.",
  "identities.messages.1040006": "Send sign up code",
  "identities.messages.1040007": "Sign up with passkey",
  "identities.messages.1040008": "Back",
  "identities.messages.1040009": "Please choose a credential to authenticate yourself with.",
  "identities.messages.1050001": "Your changes have been saved!",
  "identities.messages.1050002": "Link {provider}",
  "identities.messages.1050003": "Unlink {provider}",
  "identities.messages.1050004": "Unlink TOTP Authenticator App",
  "identities.messages.1050005": "Authenticator app QR code",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Reveal backup recovery codes",
  "identities.messages.1050008": "Enable",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "These are your back up recovery codes. Please keep them in a safe place!",
  "identities.messages.1050011": "Confirm backup recovery codes",
  "identities.messages.1050012": "Add security key",
  "identities.messages.1050013": "Name of the security key",
  "identities.messages.1050014": "Secret was used at {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Disable this method",
  "identities.messages.1050017": "Authenticator Secret",
  "identities.messages.1050018": "Remove security key \"{display_name}\"",
  "identities.messages.1050019": "Add passkey",
  "identities.messages.1050020": "Remove passkey \"{display_name}\"",
  "identities.messages.1060001": "You successfully recovered your account. Please change your password or set up an alternative login method (e.g. social sign in) within the next {privileged_session_expires_at_unix_until_minutes} minutes.",
  "identities.messages.1060002": "An email containing a recovery link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1060003": "An email containing a recovery code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1070001": "Password",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Save",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Submit",
  "identities.messages.1070006": "Verify code",
  "identities.messages.1070007": "Email",
  "identities.messages.1070008": "Resend code",
  "identities.messages.1070009": "Continue",
  "identities.messages.1070010": "Recovery code",
  "identities.messages.1070011": "Verification code",
  "identities.messages.1070012": "Registration code",
  "identities.messages.1070013": "Login code",
  "identities.messages.1070014": "Login and link credential",
  "identities.messages.1070015": "Please complete the captcha challenge to continue.",
  "identities.messages.1080001": "An email containing a verification link has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.1080002": "You successfully verified your email address.",
  "identities.messages.1080003": "An email containing a verification code has been sent to the email address you provided. If you have not received an email, check the spelling of the address and make sure to use the address you registered with.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Please enter the {property} and try again.",
  "identities.messages.4000003": "length must be >= {min_length}, but got {actual_length}",
  "identities.messages.4000004": "does not match pattern \"{pattern}\"",
  "identities.messages.4000005": "The password can not be used because {reason}.",
  "identities.messages.4000006": "The provided credentials are invalid, check for spelling mistakes in your password or username, email address, or phone number.",
  "identities.messages.4000007": "An account with the same identifier (email, phone, username, ...) exists already.",
  "identities.messages.4000008": "The provided authentication code is invalid, please try again.",
  "identities.messages.4000009": "Could not find any login identifiers. Did you forget to set them? This could also be caused by a server misconfiguration.",
  "identities.messages.4000010": "Account not active yet. Did you forget to verify your email address?",
  "identities.messages.4000011": "You have no TOTP device set up.",
  "identities.messages.4000012": "This backup recovery code has already been used.",
  "identities.messages.4000013": "You have no WebAuthn device set up.",
  "identities.messages.4000014": "You have no backup recovery codes set up.",
  "identities.messages.4000015": "This account does not exist or has no security key set up.",
  "identities.messages.4000016": "The backup recovery code is not valid.",
  "identities.messages.4000017": "length must be <= {max_length}, but got {actual_length}",
  "identities.messages.4000018": "must be >= {minimum} but found {actual}",
  "identities.messages.4000019": "must be > {minimum} but found {actual}",
  "identities.messages.4000020": "must be <= {maximum} but found {actual}",
  "identities.messages.4000021": "must be < {maximum} but found {actual}",
  "identities.messages.4000022": "{actual} not multipleOf {base}",
  "identities.messages.4000023": "maximum {max_items} items allowed, but found {actual_items} items",
  "identities.messages.4000024": "minimum {min_items} items allowed, but found {actual_items} items",
  "identities.messages.4000025": "items at index {index_a} and {index_b} are equal",
  "identities.messages.4000026": "expected {allowed_types_list}, but got {actual_type}",
  "identities.messages.4000027": "An account with the same identifier (email, phone, username, ...) exists already. Please sign in to your existing account to link your social profile.",
  "identities.messages.4000028": "You tried signing in with {credential_identifier_hint} which is already in use by another account. You can sign in using {available_credential_types_list}. You can sign in using one of the following social sign in providers: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "must be equal to constant {expected}",
  "identities.messages.4000030": "const failed",
  "identities.messages.4000031": "The password can not be used because it is too similar to the identifier.",
  "identities.messages.4000032": "The password must be at least {min_length} characters long, but got {actual_length}.",
  "identities.messages.4000033": "The password must be at most {max_length} characters long, but got {actual_length}.",
  "identities.messages.4000034": "The password has been found in data breaches and must no longer be used.",
  "identities.messages.4000035": "This account does not exist or has not setup sign in with code.",
  "identities.messages.4000036": "The provided traits do not match the traits previously associated with this flow.",
  "identities.messages.4000037": "This account does not exist or has no login method configured.",
  "identities.messages.4000038": "Captcha verification failed, please try again.",
  "identities.messages.4010001": "The login flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4010002": "Could not find a strategy to log you in with. Did you fill out the form correctly?",
  "identities.messages.4010003": "Could not find a strategy to sign you up with. Did you fill out the form correctly?",
  "identities.messages.4010004": "Could not find a strategy to update your settings. Did you fill out the form correctly?",
  "identities.messages.4010005": "Could not find a strategy to recover your account with. Did you fill out the form correctly?",
  "identities.messages.4010006": "Could not find a strategy to verify your account with. Did you fill out the form correctly?",
  "identities.messages.4010007": "The request was already completed successfully and can not be retried.",
  "identities.messages.4010008": "The login code is invalid or has already been used. Please try again.",
  "identities.messages.4010009": "Linked credentials do not match.",
  "identities.messages.4010010": "The address you entered does not match any known addresses in the current account.",
  "identities.messages.4040001": "The registration flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4040002": "The request was already completed successfully and can not be retried.",
  "identities.messages.4040003": "The registration code is invalid or has already been used. Please try again.",
  "identities.messages.4050001": "The settings flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4060001": "The request was already completed successfully and can not be retried.",
  "identities.messages.4060002": "The recovery flow reached a failure state and must be retried.",
  "identities.messages.4060004": "The recovery token is invalid or has already been used. Please retry the flow.",
  "identities.messages.4060005": "The recovery flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4060006": "The recovery code is invalid or has already been used. Please try again.",
  "identities.messages.4070001": "The verification token is invalid or has already been used. Please retry the flow.",
  "identities.messages.4070002": "The request was already completed successfully and can not be retried.",
  "identities.messages.4070003": "The verification flow reached a failure state and must be retried.",
  "identities.messages.4070005": "The verification flow expired {expired_at_unix_since_minutes} minutes ago, please try again.",
  "identities.messages.4070006": "The verification code is invalid or has already been used. Please try again.",
  "identities.messages.5000001": "{reason}",
  "login.cancel-button": "Cancel",
  "login.cancel-label": "Not the right account?",
  "login.forgot-password": "Forgot password?",
  "login.logged-in-as-label": "You are using:",
  "login.logout-button": "Logout",
  "login.logout-label": "Something's not working?",
  "login.registration-button": "Sign up",
  "login.registration-label": "Don't have an account?",
  "login.subtitle-oauth2": "To authenticate {clientName}",
  "login.title": "Sign in",
  "login.subtitle": "Sign in with {parts}",
  "login.title-aal2": "Second factor authentication",
  "login.subtitle-aal2": "Choose a way to complete your second factor authentication",
  "login.code.subtitle": "A verification code will be sent by email",
  "login.webauthn.subtitle": "Please prepare your WebAuthN device",
  "login.totp.subtitle": "Please enter the code generated by your Authenticator App",
  "login.lookup_secret.subtitle": "Please enter one of your 8-digit backup recovery codes",
  "login.title-refresh": "Reauthenticate",
  "login.subtitle-refresh": "Confirm your identity with {parts}",
  "login.2fa.go-back": "Something isn't working?",
  "login.2fa.go-back.link": "Go back",
  "login.2fa.method.go-back": "Choose another method",
  "logout.accept-button": "Yes",
  "logout.reject-button": "No",
  "logout.title": "Do you wish to log out?",
  "recovery.login-button": "Sign in",
  "recovery.login-label": "Remember your credentials?",
  "recovery.title": "Recover your account",
  "recovery.subtitle": "Enter the email address associated with your account to receive a one-time access code",
  "registration.login-button": "Sign in",
  "registration.login-label": "Already have an account?",
  "registration.subtitle-oauth2": "To authenticate {clientName}",
  "registration.title": "Register an account",
  "registration.subtitle": "Sign up with {parts}",
  "settings.navigation-back-button": "Back",
  "settings.navigation-backup-codes": "2FA Backup Codes",
  "settings.navigation-logout": "Logout",
  "settings.navigation-oidc": "Social Sign In",
  "settings.navigation-password": "Password",
  "settings.navigation-profile": "Profile",
  "settings.navigation-totp": "Authenticator App",
  "settings.navigation-webauthn": "Hardware Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Here you can manage settings related to your account. Keep in mind that certain actions require you to re-authenticate.",
  "settings.subtitle": "Update your account settings",
  "settings.title-lookup-secret": "Manage 2FA Backup Recovery Codes",
  "settings.title-navigation": "Account Settings",
  "settings.title-oidc": "Social Sign In",
  "settings.title-password": "Change Password",
  "settings.title-profile": "Profile Settings",
  "settings.title-totp": "Manage 2FA TOTP Authenticator App",
  "settings.title-webauthn": "Manage Hardware Tokens",
  "settings.title-passkey": "Manage Passkeys",
  "settings.title": "Account Settings",
  "settings.navigation.title": "Account Settings",
  "settings.password.title": "Change Password",
  "settings.password.description": "Modify your password",
  "settings.profile.title": "Profile Settings",
  "settings.profile.description": "Update your profile information",
  "settings.webauthn.title": "Manage Hardware Tokens",
  "settings.webauthn.description": "Manage your hardware token settings",
  "verification.registration-button": "Sign up",
  "verification.registration-label": "Don't have an account?",
  "verification.title": "Verify your account",
  "verification.subtitle": "Enter the email address associated with your account to verify it",
  "verification.back-button": "Back",
  "two-step.password.title": "Password",
  "two-step.password.description": "Enter your password associated with your account",
  "two-step.code.title": "Email code",
  "two-step.code.description": "A verification code will be sent to your email",
  "two-step.webauthn.title": "Security key",
  "two-step.webauthn.description": "Use your security key to authenticate",
  "two-step.passkey.title": "Passkey (recommended)",
  "two-step.passkey.description": "Use your device's for fingerprint or face recognition",
  "two-step.totp.title": "Use your Authenticator App (TOTP)",
  "two-step.totp.description": "Use a 6-digit one-time code from your authenticator app",
  "two-step.lookup_secret.title": "Backup recovery code",
  "two-step.lookup_secret.description": "Use up one of your 8-digit backup codes to authenticate",
  "identities.messages.1010020": "",
  "input.placeholder": "Enter your {placeholder}",
  "card.header.parts.oidc": "a social provider",
  "card.header.parts.password.registration": "your {identifierLabel} and a password",
  "card.header.parts.password.login": "your {identifierLabel} and password",
  "card.header.parts.code": "a code sent to your email",
  "card.header.parts.passkey": "a Passkey",
  "card.header.parts.webauthn": "a security key",
  "card.header.parts.identifier-first": "your {identifierLabel}",
  "card.header.description.login": "Sign in with {identifierLabel}",
  "card.header.description.registration": "Sign up with {identifierLabel}",
  "misc.or": "or",
  "forms.label.forgot-password": "Forgot Password?",
  "settings.totp.title": "Authenticator App",
  "settings.totp.description": "Add a TOTP Authenticator App to your account to improve your account security. Popular Authenticator Apps are LastPass and Google Authenticator",
  "settings.totp.info.not-linked": "To enable scan the QR code with your authenticator and enter the code.",
  "settings.totp.info.linked": "You currently have an authenticator app connected.",
  "settings.lookup_secret.title": "Backup Recovery Codes (second factor)",
  "settings.lookup_secret.description": "Recovery codes are a secure backup for 2FA, allowing you to regain access to your account if you lose your 2FA device.",
  "settings.oidc.title": "Connected accounts",
  "settings.oidc.description": "Connect a social login provider with your account.",
  "settings.oidc.info": "Connected accounts from these providers can be used to login to your account",
  "settings.webauthn.info": "Hardware Tokens are used for second-factor authentication or as first-factor with Passkeys",
  "settings.passkey.title": "Manage Passkeys",
  "settings.passkey.description": "Manage your passkey settings",
  "settings.passkey.info": "Manage your passkey settings",
  "card.footer.select-another-method": "Select another method",
  "account-linking.title": "Link account",
  "property.password": "password",
  "property.email": "email",
  "property.phone": "phone",
  "property.username": "username",
  "property.identifier": "identifier",
  "property.code": "code",
  "consent.title": "Authorize {party}",
  "consent.subtitle": "A third party application wants to access information associated with your account {identifier}.",
  "consent.scope.openid.title": "Identity",
  "consent.scope.openid.description": "Allows the application to verify your identity. This is required for authentication and a trusted login experience.",
  "consent.scope.offline_access.title": "Offline Access",
  "consent.scope.offline_access.description": "Allows this application to keep you signed in even when you're not actively using it.",
  "consent.scope.profile.title": "Profile Information",
  "consent.scope.profile.description": "Allows access to your basic profile details, including your username, first name, and last name.",
  "consent.scope.email.title": "Email Address",
  "consent.scope.email.description": "Retrieve your email address and its verification status.",
  "consent.scope.address.title": "Physical Address",
  "consent.scope.address.description": "Access your postal address.",
  "consent.scope.phone.title": "Phone Number",
  "consent.scope.phone.description": "Retrieve your phone number and its verification status.",
  "error.title.what-happened": "What happened?",
  "error.title.what-can-i-do": "What can I do?",
  "error.instructions": "Please try again in a few minutes or contact the website operator.",
  "error.footer.text": "When reporting this error, please include the following information:",
  "error.footer.copy": "Copy",
  "error.action.go-back": "Go back"
}
